<template>
  <div>
    <h4
      class="chart-title ts-flex ts-justify-between"
      :class="{ 'text-gray': !inverseMode }"
    >
      <strong> {{ $t('studentPerformance.pageTitle') }} </strong>
    </h4>
    <ts-loading-banner :loading="loading">
      <div
        class="widget-chart-full-width ts-px-4"
        :class="{ 'nvd3-inverse-mode': inverseMode }"
      >
        <p>
          {{
            $t(
              'studentPerformance.The_Chart_of_the_Student_Performance_in_all_the_Subjects_and_for_all_Grade_Levels'
            )
          }}
        </p>
        <bar-chart
          :data="{
            labels: labels,
            datasets: datasets
          }"
          :options="options"
          style="min-height: 400px; height: 450px"
        ></bar-chart>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import BarChart from '@/components/vue-chartjs/BarChart'
import { keys, map } from 'lodash'

export default {
  components: {
    BarChart
  },
  props: ['inverseMode', 'loading', 'value'],
  data() {
    return {
      filters: {
        term_name: 'Term',
        acps_abbr: 'Sub Progam',
        acp_abbr: 'Academic Progam',
        ac_year: 'Academic Year'
      },
      selectedFilter: '',

      // BarChart student grade
      grades: [],
      resources: [],
      borderColor: [
        '#00acac',
        '#5B9BD5',
        '#ED7D31',
        '#A5A5A5',
        '#FFC000',
        '#FF0000'
      ],
      backgroundColor: [
        'rgba(0, 172, 172, 0.9)',
        'rgba(91, 155, 213, 0.9)',
        'rgba(237, 125, 49, 0.9)',
        'rgba(165, 165, 165, 0.9)',
        'rgba(255, 192, 0, 0.9)',
        'rgba(255, 0, 0, 0.9)'
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function(value) {
                  return value + '%'
                }
              }
            }
          ]
        },
        legend: {
          position: 'top'
        },
      }
    }
  },
  computed: {
    // bar chart
    labels() {
      return keys(this.resources)
    },
    datasets() {
      return this.grades.map((grade, index) => {
        return {
          label: grade.definition_name,
          borderColor: this.borderColor[index],
          backgroundColor: this.backgroundColor[index],
          borderWidth: 1,
          data: map(this.resources, r => {
            return r[grade.grade]
          }),
          datalabels: {
            align: 'start',
            anchor: 'end',
            offset: -20
          }
        }
      })
    }
  },
  mounted() {
    this.selectedFilter = Object.keys(this.filters)[0]
  },
  watch: {
    value: {
      handler(val) {
        this.grades = val.grades
        this.resources = val.resources
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style scoped>
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.text-gray {
  color: #585a5e;
}
</style>
